import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from './cn.js';

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  function Select({ className, children, ...rest }, ref) {
    return (
      <div className="relative">
        <select
          ref={ref}
          {...rest}
          className={cn(
            'h-12 w-full appearance-none rounded-xl border border-line bg-surface-2 pl-4 pr-10 text-base text-text',
            'focus:outline-none focus:border-gold/40 focus:bg-surface-3 transition',
            className,
          )}
        >
          {children}
        </select>
        <svg
          className="pointer-events-none absolute right-3.5 top-1/2 -translate-y-1/2 h-4 w-4 text-text-muted"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <path d="m6 8 4 4 4-4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
    );
  },
);
